import { FC } from "react";

import { FormType } from "@simplyk/common";
import { useWatch } from "react-hook-form";

import { useFormV2Context } from "../../../../contexts/FormV2Context";

import { useTranslate } from "@/common/hooks/useTranslate";
import { FormTypography } from "@/forms-design-system/FormTypography";

export const TicketingWelcomeMessage: FC = () => {
  const { t } = useTranslate();
  const { form, membershipInfo } = useFormV2Context(FormType.Ticketing);
  const firstName = useWatch({ control: form.control, name: "firstName" });

  if (!firstName || membershipInfo.isAuthenticated) {
    return null;
  }

  return (
    <FormTypography variant="subtitle1" vibe="intense">
      {t("ticketing", "form.welcomeMessage", { firstName })}
    </FormTypography>
  );
};
